export default "__VITE_ASSET__DHSuF2Xg__"